<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M346 1255 c-11 -11 -39 -15 -114 -15 -90 0 -100 -2 -120 -23 l-22
-23 0 -576 c0 -572 0 -575 21 -594 20 -18 41 -19 350 -19 211 0 330 4 331 10
2 6 -111 11 -321 13 -285 2 -327 4 -343 19 -17 15 -18 48 -18 573 0 464 2 559
14 576 12 16 29 20 110 22 l96 4 10 -27 c5 -14 10 -28 10 -31 0 -2 -40 -4 -90
-4 -85 0 -90 -1 -95 -22 -3 -13 -4 -252 -3 -533 l3 -510 356 -3 355 -2 12 -34
c24 -65 106 -69 132 -7 13 31 1 74 -25 88 -8 5 -18 25 -21 44 -4 30 -1 36 29
55 30 19 37 20 61 7 14 -7 26 -20 26 -28 0 -23 38 -55 65 -55 32 0 65 33 65
65 0 33 -33 65 -68 65 -15 0 -37 7 -49 15 -19 13 -20 19 -11 49 10 32 13 33
48 29 31 -4 40 -1 58 22 27 35 28 55 1 89 -22 27 -56 34 -89 16 -15 -8 -20 -6
-25 10 -9 30 20 70 50 70 36 0 65 33 65 74 0 40 -28 66 -70 66 -31 0 -70 -37
-70 -67 0 -11 -9 -28 -20 -38 -19 -17 -22 -18 -55 -2 l-35 17 -2 257 -3 258
-87 3 c-49 1 -88 5 -88 7 0 2 5 16 10 30 10 27 10 27 105 23 59 -2 99 -8 107
-16 10 -10 14 -71 16 -242 2 -136 7 -230 13 -230 5 0 9 92 9 230 l0 231 -25
24 c-22 23 -31 25 -123 25 -76 0 -102 4 -112 15 -10 12 -47 15 -211 15 -162 0
-200 -3 -213 -15z m398 -11 c24 -9 19 -40 -13 -76 l-29 -33 -118 -4 c-145 -4
-188 7 -211 54 -30 63 -25 65 176 65 99 0 186 -3 195 -6z m-189 -125 c83 0
201 3 263 6 l112 6 0 -165 c0 -152 -6 -187 -25 -156 -8 13 -51 13 -75 0 -26
-14 -34 -57 -15 -86 23 -35 19 -73 -7 -83 -17 -7 -26 -5 -35 7 -27 37 -35 42
-65 42 -17 0 -40 -7 -50 -17 -24 -22 -24 -77 2 -103 30 -30 24 -40 -23 -40
-32 0 -45 5 -55 20 -29 47 -101 41 -122 -9 -24 -58 31 -117 86 -92 19 8 36 8
65 1 36 -10 39 -13 40 -48 0 -20 4 -46 8 -57 10 -26 -26 -55 -68 -55 -62 0
-80 -81 -25 -117 24 -15 29 -15 53 -2 14 8 31 25 37 37 18 37 52 56 70 41 13
-10 12 -15 -7 -32 -17 -16 -20 -28 -16 -63 l5 -44 -259 0 -259 0 0 511 0 510
108 -6 c59 -3 175 -6 257 -6z m339 -335 c20 -19 20 -38 1 -54 -8 -7 -15 -28
-15 -46 0 -19 -4 -34 -10 -34 -5 0 -10 15 -10 34 0 18 -7 39 -15 46 -18 15
-19 42 -3 58 16 16 33 15 52 -4z m36 -99 c0 -38 -15 -47 -25 -15 -6 18 8 50
21 50 2 0 4 -16 4 -35z m232 8 c35 -31 16 -73 -34 -73 -21 0 -34 -9 -54 -40
-23 -35 -25 -44 -15 -66 14 -32 7 -44 -25 -44 -13 0 -24 -4 -24 -10 0 -5 18
-10 40 -10 32 0 46 6 64 27 21 24 26 26 50 15 20 -9 26 -19 26 -42 0 -39 -33
-55 -68 -34 -26 17 -83 7 -90 -15 -3 -10 2 -12 22 -7 25 6 27 5 21 -16 -15
-51 -58 -109 -95 -130 -38 -22 -39 -24 -33 -68 4 -31 13 -51 29 -63 40 -31 26
-87 -21 -87 -41 0 -58 40 -34 79 9 14 8 28 -6 64 -15 41 -21 47 -46 47 -31 0
-36 9 -17 28 8 8 9 15 1 23 -17 17 -51 -50 -45 -89 8 -56 -37 -82 -72 -43 -23
25 -13 56 22 73 27 13 45 68 23 68 -6 0 -11 -4 -11 -10 0 -17 -18 -11 -41 13
-31 32 -59 97 -59 139 0 35 -2 37 -52 52 -34 10 -56 12 -62 6 -14 -14 -50 -12
-64 2 -16 16 -15 53 2 68 22 17 60 8 71 -17 9 -21 42 -33 95 -33 18 0 31 8 40
26 l14 25 17 -23 c23 -30 38 -14 18 20 -9 17 -25 28 -41 30 -35 4 -52 26 -44
56 14 54 86 39 86 -17 0 -25 7 -39 31 -56 37 -28 51 -20 21 12 -12 13 -22 26
-22 29 0 4 22 11 48 17 52 11 96 4 153 -24 37 -18 37 -18 73 10 26 20 36 35
36 56 0 43 40 62 72 32z m-472 -407 c0 -8 -9 -18 -20 -21 -11 -4 -27 -22 -35
-41 -8 -19 -21 -34 -29 -34 -29 0 -46 13 -46 35 0 29 23 48 48 41 12 -4 29 1
43 13 29 24 39 26 39 7z m458 -26 c38 0 61 -32 41 -56 -19 -23 -63 -14 -67 13
-2 13 -17 30 -33 40 -30 18 -34 25 -22 36 3 4 16 -2 28 -13 12 -11 35 -20 53
-20z m-257 -98 c14 -38 4 -52 -36 -52 -32 0 -35 2 -25 19 5 11 10 31 10 44 0
21 4 24 21 20 11 -3 25 -17 30 -31z"
      />
      <path
        d="M340 1020 c0 -6 80 -10 220 -10 140 0 220 4 220 10 0 6 -80 10 -220
10 -140 0 -220 -4 -220 -10z"
      />
      <path
        d="M390 930 c0 -6 -29 -10 -68 -10 -40 0 -73 -5 -80 -12 -16 -16 -16
-150 0 -166 16 -16 142 -16 156 1 16 19 20 197 5 197 -7 0 -13 -4 -13 -10z
m-20 -35 c0 -11 -34 -75 -40 -75 -4 0 -12 11 -18 25 -12 25 -32 34 -32 14 0
-14 44 -89 52 -89 4 0 19 21 32 48 l25 47 1 -52 0 -53 -65 0 -65 0 0 70 0 70
55 0 c30 0 55 -2 55 -5z"
      />
      <path
        d="M440 870 c0 -6 82 -10 225 -10 143 0 225 4 225 10 0 6 -82 10 -225
10 -143 0 -225 -4 -225 -10z"
      />
      <path
        d="M447 764 c-18 -18 15 -24 129 -24 96 0 125 3 122 13 -5 13 -238 24
-251 11z"
      />
      <path
        d="M395 670 c-3 -5 -33 -10 -66 -10 -92 0 -99 -7 -99 -93 0 -44 5 -78
12 -85 17 -17 157 -16 163 1 2 6 5 54 7 105 3 85 -2 107 -17 82z m-42 -75
c-20 -42 -25 -43 -43 -10 -14 25 -30 33 -30 15 0 -18 40 -90 50 -90 5 0 20 19
32 43 l23 42 3 -39 c5 -61 0 -66 -68 -66 l-60 0 0 70 0 70 55 0 55 0 -17 -35z"
      />
      <path
        d="M390 400 c0 -6 -29 -10 -68 -10 -40 0 -73 -5 -80 -12 -16 -16 -16
-150 0 -166 16 -16 142 -16 156 1 16 19 20 197 5 197 -7 0 -13 -4 -13 -10z
m-20 -35 c0 -11 -34 -75 -40 -75 -4 0 -12 11 -18 25 -12 26 -32 34 -32 12 0
-13 50 -91 55 -85 2 2 15 23 29 48 l26 45 0 -52 0 -53 -65 0 -65 0 0 70 0 70
55 0 c30 0 55 -2 55 -5z"
      />
      <path
        d="M868 569 c-18 -10 -25 -39 -9 -39 5 0 14 7 21 15 19 22 47 18 65 -9
24 -36 5 -68 -38 -66 -47 3 -51 1 -37 -15 32 -39 110 2 110 58 0 53 -64 84
-112 56z"
      />
      <path
        d="M725 458 c-28 -16 -35 -28 -35 -64 0 -35 24 -62 59 -66 35 -4 37 18
2 25 -34 7 -48 36 -31 67 14 26 56 26 72 0 13 -21 38 -27 38 -10 0 18 -48 60
-67 60 -10 0 -27 -6 -38 -12z"
      />
      <path
        d="M950 392 c0 -5 11 -14 25 -20 19 -9 25 -19 25 -42 0 -52 -69 -60 -85
-10 -8 26 -25 26 -25 0 0 -54 79 -79 118 -37 28 29 28 67 2 95 -20 21 -60 30
-60 14z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
